/*
export replaceAll(s : string, m : string, r : string, p : string): string{
    if( s == p || r.indexOf(m) > -1){
        return s;
    }else{
        this.replaceAll(s.replace(m, r), m, r, s);
    }
}
*/
export function replaceAll(str, find, replace) {
  var escapedFind = find.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
  return str.replace(new RegExp(escapedFind, "g"), replace);
}

export function guid() {
  return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
}

function s4(): string {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
}

export function generatePassword(passwordLength: number): string {
  var allChars, lowerChars, numberChars, randPasswordArray, upperChars;
  numberChars = "0123456789";
  upperChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  lowerChars = "abcdefghiklmnopqrstuvwxyz";
  allChars = numberChars + upperChars + lowerChars;
  randPasswordArray = Array(passwordLength);
  randPasswordArray[0] = numberChars;
  randPasswordArray[1] = upperChars;
  randPasswordArray[2] = lowerChars;
  randPasswordArray = randPasswordArray.fill(allChars, 3);
  return shuffleArray(
    randPasswordArray.map(function (x) {
      return x[Math.floor(Math.random() * x.length)];
    }),
  ).join("");
}

function shuffleArray(array) {
  var i, j, temp;
  i = array.length - 1;
  while (i > 0) {
    j = Math.floor(Math.random() * (i + 1));
    temp = array[i];
    array[i] = array[j];
    array[j] = temp;
    i--;
  }
  return array;
}

export function b64_encode_autologin(s): string {
  s = encodeURIComponent(s);
  s = btoa(s);
  s = s.replace(/\=/g, "-");
  return s;
}

export const FUTURE_TIME = 2000000000000;

export function AM_STATUSES(): Array<any> {
  return [
    { id: "OPEN", color: "#BC163A" },
    { id: "IN_PROCESS", color: "#EF7814" },
    { id: "DONE", color: "#66BB93" },
  ];
}

export function validateEmail(email): any {
  return /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()\.,;\s@\"]+\.{0,1})+([^<>()\.,;:\s@\"]{2,}|[\d\.]+))$/.test(
    email,
  );
}

// This rule lives in four copies, because the repositories share no package:
//   dashboard-backend/server/utils/password_policy.py
//   manage-backend/server/utils/password_policy.py
//   dashboard-frontend/src/app/shared/password-policy.ts
//   manage-frontend/src/app/shared/utils.ts
// It governs portal logins. generatePassword above is for survey respondents and
// answers to nothing here.
//
// Nothing here enforces the rule; that is the password policy on the Firebase
// project.
export const PASSWORD_MIN_LENGTH = 14;

// What counts as "special" is Firebase's own non-alphanumeric set, minus the characters
// the reset screens refuse. Firebase permits + - and = in a password but does not count
// them as non-alphanumeric, and manage sets a password straight through Firebase, so a
// wider set here would tick the box for a password Firebase then refuses.
// https://docs.cloud.google.com/identity-platform/docs/password-policy
export const SPECIAL_CHARACTERS = "^$*.[]{}()?!@#%&\\,><':;|_~`";
const FORBIDDEN_CHARACTERS = ' /"';

const LOWERCASE = "abcdefghijklmnopqrstuvwxyz";
const UPPERCASE = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const DIGITS = "0123456789";

export interface PasswordRules {
  isLongEnough: boolean;
  hasLowercase: boolean;
  hasUppercase: boolean;
  hasNumber: boolean;
  hasSpecialChar: boolean;
  noForbiddenChar: boolean;
}

// Character-set membership rather than a regular expression: a range like [A-z] also
// quietly covers [ \ ] ^ _ and `, and the backends have to agree with this character
// for character. Array.from walks code points where split("") and .length walk UTF-16
// units, so an emoji counts as the one character the backends count it as.
function containsAny(password: string, characters: string): boolean {
  return Array.from(password).some((character) =>
    characters.includes(character),
  );
}

export function checkPassword(password: string): PasswordRules {
  return {
    isLongEnough: Array.from(password).length >= PASSWORD_MIN_LENGTH,
    hasLowercase: containsAny(password, LOWERCASE),
    hasUppercase: containsAny(password, UPPERCASE),
    hasNumber: containsAny(password, DIGITS),
    hasSpecialChar: containsAny(password, SPECIAL_CHARACTERS),
    noForbiddenChar: !containsAny(password, FORBIDDEN_CHARACTERS),
  };
}

export function isPasswordValid(rules: PasswordRules): boolean {
  return (
    rules.isLongEnough &&
    rules.hasLowercase &&
    rules.hasUppercase &&
    rules.hasNumber &&
    rules.hasSpecialChar &&
    rules.noForbiddenChar
  );
}
